import { render, staticRenderFns } from "./sideConfigSandbox.vue?vue&type=template&id=672b5cfc&scoped=true"
import script from "./sideConfigSandbox.vue?vue&type=script&lang=js"
export * from "./sideConfigSandbox.vue?vue&type=script&lang=js"
import style0 from "./sideConfigSandbox.vue?vue&type=style&index=0&id=672b5cfc&prod&scoped=true&lang=css"
import style1 from "./sideConfigSandbox.vue?vue&type=style&index=1&id=672b5cfc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672b5cfc",
  null
  
)

export default component.exports